export default __webpack_public_path__ + "static/media/universiteti-isa-boletini.f3e750a2.jpeg";